import { useTranslation } from "react-i18next";

export default function CancelPolicy() {
  const { t } = useTranslation();
  return (
    <div className="cnl-policy ">
      <h3 className="sub mb-6">{t("bck_ttl_ccl_bk")}</h3>

      {/* 취소정책 */}
      <ul>
        <li>
          <span>{t("th_1_ccl_plcy_bk")}</span>
          <span>{t("txt_ccl_plcy_1_bk")}</span>
        </li>
        <li>
          <span>{t("th_2_ccl_plcy_bk")}</span>
          <span>{t("txt_ccl_plcy_1_bk")}</span>
        </li>
        <li>
          <span>{t("th_3_ccl_plcy_bk")}</span>
          <span>{t("txt_ccl_plcy_3_bk")}</span>
        </li>
      </ul>
    </div>
  );
}
